export default "__VITE_ASSET__DgQb_XWj__"